import React, { useRef, useEffect } from 'react';

import IconSearch from '@/assets/icons/icon-search.svg?react';
import IconCancel from '@/assets/icons/icon-cancel.svg?react';

interface InlineSearchProps {
  value: string;
  onChange: (value: string) => void;
  onClose: () => void;
}

export const InlineSearch: React.FC<InlineSearchProps> = ({ value, onChange, onClose }) => {
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  return (
    <div
      className="flex h-8 flex-1 items-center gap-2 rounded-lg bg-neutral-50 px-2"
      onClick={(e) => e.stopPropagation()}
    >
      <IconSearch className="h-4 w-4 shrink-0 text-neutral-400" />
      <input
        ref={inputRef}
        type="text"
        aria-label="Search"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder="Search..."
        className="min-w-0 flex-1 bg-transparent text-xs leading-4 font-medium text-neutral-900 outline-none placeholder:text-neutral-400"
      />
      <button
        type="button"
        aria-label="Close search"
        onClick={onClose}
        className="flex h-5 w-5 shrink-0 cursor-pointer items-center justify-center rounded transition-colors hover:bg-neutral-100"
      >
        <IconCancel className="h-3.5 w-3.5 text-neutral-400" />
      </button>
    </div>
  );
};
